// extracted by mini-css-extract-plugin
var _1 = "ConfirmationStyle-module__confirmation___ZhYRU";
var _2 = "ConfirmationStyle-module__counter___NiLbA";
var _3 = "ConfirmationStyle-module__notice___M0mx0";
export { _1 as "confirmation", _2 as "counter", _3 as "notice" }
